<template>
  <v-card class="pa-2 my-2" dark>
    <v-card-title>{{ uriType }} URIs</v-card-title>
    <v-card-text>
      <v-flex>
        <v-data-iterator
          hide-default-footer
          :disable-pagination="true"
          :items="uris">
          <template v-slot:default="props">
            <v-layout
              v-for="(item, index) in props.items"
              :key="index"
              wrap>
              <v-flex xs8>
                <v-text-field
                  :value="item.uri"
                  :label="`${uriType} URI ${index + 1}`"
                  @input="updateUri(index, $event)">
                </v-text-field>
              </v-flex>
              <v-flex class="align-self-center" xs4>
                <v-spacer></v-spacer>
                <v-icon @click="deleteUri(item.clientRedirectUrisId)" v-if="resolveIdValue(item) && item.uri">
                  mdi-delete
                </v-icon>
                <span class="align-self-center" v-if="index===props.items.length-1">
                  <v-icon v-if="!resolveIdValue(item) && !item.uri" @click="cancelUri(index)">
                    mdi-cancel
                  </v-icon>
                  <v-icon v-if="!resolveIdValue(item) && item.uri" @click="saveUri(index)">
                    mdi-content-save
                  </v-icon>
                  <v-icon v-if="resolveIdValue(item)" @click="newUri">
                    mdi-plus
                  </v-icon>
                </span>
              </v-flex>

            </v-layout>
          </template>
        </v-data-iterator>
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: ['clientRedirectUris', 'uriType'],
  methods:{
    newUri () {
      this.$eventHub.$emit(this.newEvent)
    },
    updateUri (i, e) {
      this.$eventHub.$emit(this.updateEvent, { i, e })
    },
    saveUri (i) {
      this.$eventHub.$emit(this.saveEvent, i)
    },
    cancelUri (i) {
      this.$eventHub.$emit(this.cancelEvent, i)
    },
    deleteUri (i) {
      this.$eventHub.$emit(this.deleteEvent, i)
    },
    resolveIdValue (item) {
      let id = item[`client${this.lodash.upperFirst(this.uriKey)}sId`]
      return id
    }
  },
  computed: {
    uris() {
      return this.clientRedirectUris.map(u => {
        u.uri = u[this.uriKey]
        return u
      })
    },
    uriKey () {
      return `${this.lodash.camelCase(this.uriType)}Uri`
    },
    newEvent () {
      return `new${this.lodash.upperFirst(this.lodash.camelCase(this.uriType))}Uri`
    },
    updateEvent () {
      return `update${this.lodash.upperFirst(this.lodash.camelCase(this.uriType))}Uri`
    },
    cancelEvent () {
      return `cancel${this.lodash.upperFirst(this.lodash.camelCase(this.uriType))}Uri`
    },
    saveEvent () {
      return `save${this.lodash.upperFirst(this.lodash.camelCase(this.uriType))}Uri`
    },
    deleteEvent () {
      return `delete${this.lodash.upperFirst(this.lodash.camelCase(this.uriType))}Uri`
    }
  },
  created () {
    if (this.clientRedirectUris && this.clientRedirectUris.length === 0) {
      this.newUri()
    }
  }
}
</script>